import React from 'react';
import BasciLayout from './containers/BasciLayout'
import './App.css';

function App() {
  return (
    <div className="App">
      <BasciLayout />
    </div>
  );
}

export default App;
